
        var result = require("!!../../../../node_modules/css-loader/index.js!./preview.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/preview/preview.component.css
// module id = 480
// module chunks = 2